import React from 'react';
import { getImageUrlFromGoogleUserContent, Col, styled, Row } from '@teko/ds-desktop';
import { t } from '../../../i18n.es.js';
import { Countdown } from '../../Countdown/Countdown.es.js';
import { ProductCarousel } from '../../ProductCarousel/ProductCarousel.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FlashSale = ({
  productsCarousel,
  endAt,
  backgroundImage
}) => {
  return /* @__PURE__ */ React.createElement(StyledRow, {
    bgImage: backgroundImage ? getImageUrlFromGoogleUserContent(backgroundImage, {
      width: 1232
    }) : "https://shopfront-cdn.tekoapis.com/static/washing_machine.png"
  }, /* @__PURE__ */ React.createElement(StyledCol, {
    span: 2
  }, endAt && /* @__PURE__ */ React.createElement(EndAt, null, /* @__PURE__ */ React.createElement("p", {
    style: { marginBottom: "1rem" }
  }, t("K\u1EBFt th\xFAc sau")), " ", /* @__PURE__ */ React.createElement(Countdown, {
    date: endAt
  }))), /* @__PURE__ */ React.createElement(Col, {
    span: 10
  }, /* @__PURE__ */ React.createElement(StyledProductCarousel, __spreadValues({}, productsCarousel))));
};
const EndAt = styled.div`
  position: relative;
  top: 6rem;
`;
const StyledRow = styled(Row)`
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 1rem 0;
`;
const StyledProductCarousel = styled(ProductCarousel)`
  padding: 1rem;
`;
const StyledCol = styled(Col)`
  padding-left: 0.5rem;
  text-align: center;
  color: white;
`;

export { FlashSale };
